// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteButton__delete-eed4d1 {
  position: absolute;
  opacity: 0;
  inset-inline-end: 8px;
  top: 8px;
  flex: 0 0 auto;
  transition: opacity 0.25s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/components/DeleteButton/DeleteButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,qCAAA;AACF","sourcesContent":[".delete {\n  position: absolute;\n  opacity: 0;\n  inset-inline-end: 8px;\n  top: 8px;\n  flex: 0 0 auto;\n  transition: opacity 0.25s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete": `DeleteButton__delete-eed4d1`
};
module.exports = ___CSS_LOADER_EXPORT___;
